import { render, staticRenderFns } from "./AiAppSettingDefinitionEdit.vue?vue&type=template&id=25672b5f&scoped=true"
import script from "./AiAppSettingDefinitionEdit.vue?vue&type=script&lang=js"
export * from "./AiAppSettingDefinitionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25672b5f",
  null
  
)

export default component.exports